<!-- Mobile View - Bottom Drawer -->
@if (isVisible() && isMobile()) {
  <app-foxera-drawer-bottom
    [(visible)]="isVisible"
    [title]="heading()"
    [showContentBackground]="false">

    <div class="flex flex-col items-center text-center px-2 py-4">
      <!-- Icon -->
      <div class="mb-4">
        <span [class]="icon() + ' text-5xl text-red-500'"></span>
      </div>

      <!-- Subtitle -->
      <p class="text-grey-600 text-sm mb-6">
        {{subtitle()}}
      </p>

      <!-- Action Buttons -->
      <div class="flex flex-col w-full gap-3">
        <p-button
          [label]="isLoading ? loadingLabel : confirmLabel"
          size="large"
          [severity]="confirmSeverity"
          (click)="onConfirm()"
          [disabled]="isLoading"
          styleClass="w-full">
          @if (isLoading) {
            <i class="pi pi-spinner animate-spin mr-2"></i>
          }
        </p-button>

        <p-button
          [label]="cancelLabel"
          size="large"
          severity="secondary"
          (click)="onCancel()"
          [disabled]="isLoading"
          styleClass="w-full" />
      </div>
    </div>
  </app-foxera-drawer-bottom>
}

<!-- Desktop View - Centered Modal -->
@if (isVisible() && !isMobile()) {
  <div
    class="inset-0 z-[1200] flex items-center justify-center min-h-0"
    [class.fixed]="!quadView()"
    [class.absolute]="quadView()"
    [class.p-6]="quadView()">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/30 backdrop-blur-[2px]"></div>

    <!-- Popup Card: quad = bounded inside panel; single = fullscreen overlay -->
    <div
      class="relative bg-white shadow-[0px_2px_20px_0px_rgba(0,0,0,0.25)] z-[1201]"
      [ngClass]="quadView()
        ? 'rounded-[28px] w-full max-w-[min(30rem,calc(100%-2rem))] max-h-[min(85%,calc(100%-3rem))] h-auto'
        : 'rounded-[32px] w-[30.0625rem] max-w-[90vw] h-[23.75rem]'">
      <div
        class="w-full h-full flex flex-col items-center justify-between text-center"
        [class]="quadView() ? 'p-6 gap-4' : 'p-[2rem]'">
        <!-- Close Icon - always a pure dismissal, never onCancel()'s action -->
        <div class="size-[1.875rem] self-end flex justify-center items-center select-none">
          <span (click)="onClose()" class="cursor-pointer text-grey-300
            icon-close-rounded text-[1.7rem] hover:scale-[1.1] duration-100 ease-in-out">
          </span>
        </div>

        <!-- Warning Icon -->
        <div class="select-none" [class]="quadView() ? '' : 'mb-[1.5rem]'">
          <span [class]="icon() + ' text-red-500 select-none'" [ngClass]="quadView() ? 'text-[2.75rem]' : 'text-[3.75rem]'"></span>
        </div>

        <!-- Title -->
        <h2 class="font-[500] text-grey-900 select-none" [ngClass]="quadView() ? 'text-xl' : 'text-[1.5rem]'">
          {{heading()}}
        </h2>

        <!-- Description -->
        <p class="text-grey-500 select-none" [class]="quadView() ? 'mb-2 text-sm' : 'mb-[3rem]'">
          {{subtitle()}}
        </p>

        <!-- Action Buttons -->
        <div class="flex w-full justify-end items-stretch" [class]="quadView() ? 'gap-3' : 'gap-[20px]'">
          <p-button
            [label]="cancelLabel"
            size="large"
            severity="secondary"
            (click)="onCancel()"
            [disabled]="isLoading" />
          <p-button
            [label]="isLoading ? loadingLabel : confirmLabel"
            size="large"
            [severity]="confirmSeverity"
            (click)="onConfirm()"
            [disabled]="isLoading">
            @if (isLoading) {
              <i class="pi pi-spinner animate-spin mr-2"></i>
            }
          </p-button>
        </div>
      </div>
    </div>
  </div>
}
